// AI Initiative Discovery questionnaire. Keys mirror /app/backend/discovery.py SECTIONS.
export const discoverySections = [
  {
    id: 'organization',
    title: 'Your organization',
    intro: 'The essentials, so we know who we’re talking to.',
    fields: [
      { key: 'companyName', label: 'Company name', type: 'text', required: true, placeholder: 'Acme Logistics Inc.', autoComplete: 'organization' },
      { key: 'contactName', label: 'Your name', type: 'text', required: true, placeholder: 'Alex Morgan', autoComplete: 'name' },
      { key: 'role', label: 'Role / title', type: 'text', placeholder: 'Director of Operations' },
      { key: 'email', label: 'Email', type: 'email', required: true, placeholder: 'alex@company.com', autoComplete: 'email' },
      { key: 'phone', label: 'Phone', type: 'tel', placeholder: '+1 (416) 555-0134', autoComplete: 'tel' },
      { key: 'website', label: 'Website', type: 'text', placeholder: 'company.com' },
      { key: 'industry', label: 'Industry', type: 'select', placeholder: 'Select your industry', options: ['Technology & software', 'Financial services', 'Healthcare & life sciences', 'Manufacturing', 'Retail & e-commerce', 'Logistics & supply chain', 'Professional services', 'Public sector', 'Education', 'Energy & utilities', 'Real estate & construction', 'Other'] },
      { key: 'companySize', label: 'Company size', type: 'select', placeholder: 'Select company size', options: ['1–10 employees', '11–50 employees', '51–200 employees', '201–1,000 employees', '1,000+ employees'] },
    ],
  },
  {
    id: 'today',
    title: 'Where things stand today',
    intro: 'Context on the moment you’re in right now.',
    fields: [
      { key: 'trigger', label: 'What’s prompting this now', type: 'textarea', placeholder: 'A growth push, a hiring freeze, a backlog, a new system rollout…' },
      { key: 'teams', label: 'Teams involved', type: 'multiselect', options: ['Operations', 'Sales', 'Customer service', 'Finance', 'HR', 'IT', 'Marketing', 'Other'] },
      { key: 'currentSystems', label: 'Current systems in use', type: 'text', placeholder: 'Salesforce, NetSuite, Zendesk, Excel…' },
    ],
  },
  {
    id: 'automation',
    title: 'Process automation',
    intro: 'Where the manual hours are going today.',
    fields: [
      { key: 'manualProcesses', label: 'Which processes take the most manual effort', type: 'multiselect', options: ['Data entry', 'Invoicing', 'Reporting', 'Scheduling', 'Approvals', 'Document processing', 'Order / inventory', 'Other'] },
      { key: 'hoursPerWeek', label: 'Hours per week spent on this', type: 'select', placeholder: 'Select an estimate', options: ['Under 5 hours', '5–10 hours', '10–20 hours', '20–40 hours', '40+ hours', 'Not sure'] },
      { key: 'systemsTouched', label: 'Systems touched', type: 'text', placeholder: 'Which tools does the work pass through?' },
    ],
  },
  {
    id: 'agents',
    title: 'AI agents & assistants',
    intro: 'Where a always-on assistant could carry the load.',
    fields: [
      { key: 'agentAreas', label: 'Where an agent would help', type: 'multiselect', options: ['Customer support', 'Internal knowledge', 'Sales / lead qualification', 'IT helpdesk', 'Scheduling', 'Voice / phone', 'Other'] },
      { key: 'agentUsers', label: 'Who would use it', type: 'radio', options: ['Customers', 'Employees', 'Both'] },
      { key: 'channels', label: 'Channels', type: 'multiselect', options: ['Website chat', 'Email', 'Phone', 'WhatsApp', 'SMS', 'Microsoft Teams', 'Slack', 'Mobile app', 'Other'] },
    ],
  },
  {
    id: 'data',
    title: 'Data & systems',
    intro: 'What we’d be building on top of.',
    fields: [
      { key: 'dataReadiness', label: 'Data readiness', type: 'radio', options: ['Centralized', 'Scattered across systems', 'Mostly manual', 'Not sure'] },
      { key: 'systemsToConnect', label: 'Systems to connect', type: 'text', placeholder: 'CRM, ERP, ticketing, data warehouse…' },
      { key: 'compliance', label: 'Compliance requirements', type: 'textarea', placeholder: 'PIPEDA, HIPAA, SOC 2, data residency… (optional)' },
    ],
  },
  {
    id: 'goals',
    title: 'Goals & timeline',
    intro: 'What a win looks like, and by when.',
    fields: [
      { key: 'primaryGoal', label: 'Primary goal', type: 'radio', options: ['Reduce manual effort', 'Cut operating costs', 'Improve response times', 'Increase revenue', 'Improve accuracy & compliance', 'Scale without adding headcount', 'Explore what’s possible'] },
      { key: 'successMeasure', label: 'How success is measured', type: 'textarea', placeholder: 'Hours saved, cost per ticket, cycle time, CSAT…' },
      { key: 'timeline', label: 'Target timeline', type: 'select', placeholder: 'Select a timeline', options: ['Immediately', '1–3 months', '3–6 months', '6–12 months', 'Exploring only'] },
      { key: 'budget', label: 'Budget range', type: 'select', placeholder: 'Select a range', options: ['Under $10k', '$10k–$25k', '$25k–$50k', '$50k–$100k', '$100k+', 'Not sure yet'] },
    ],
  },
  {
    id: 'closing',
    title: 'Anything else',
    intro: 'The last word is yours.',
    fields: [
      { key: 'notes', label: 'Notes', type: 'textarea', placeholder: 'Anything we should know before we speak?' },
      { key: 'contactPreference', label: 'Best way to reach you', type: 'radio', options: ['Email', 'Phone', 'Video call'] },
      { key: 'referralSource', label: 'How you heard about us', type: 'select', placeholder: 'Select one', options: ['Google search', 'LinkedIn', 'Referral', 'Event / conference', 'Existing client', 'Other'] },
    ],
  },
];

export const requiredKeys = discoverySections.flatMap(s => s.fields.filter(f => f.required).map(f => f.key));
export const allFields = discoverySections.flatMap(s => s.fields);
export const emptyAnswers = Object.fromEntries(allFields.map(f => [f.key, f.type === 'multiselect' ? [] : '']));
